import script from "./documents.vue?vue&type=script&setup=true&lang=js"
export * from "./documents.vue?vue&type=script&setup=true&lang=js"

import "./documents.vue?vue&type=style&index=0&id=0fc7ca3b&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc7ca3b"]])

export default __exports__